import React from "react";
import { useQueryClient } from "react-query";
import { SelectEntityAsync } from "@knowfully/ui.common";
import useGlobalContext from "hooks/globalData";
import {
  OrganizationUserListItem,
  AdminListRequestOfSearchOrganizationUsersFilter,
  SearchOrganizationUsersFilter,
  ListResponseOfOrganizationUserListItem,
} from "services/KnowfullyAdminClient";

type UserSearchSelectProps = {
  value?: string | null;
  onChange: (userId: string | null) => void;
  organizationId?: string;
  label?: string;
};

export const UserSearchSelect: React.FC<UserSearchSelectProps> = ({
  value,
  onChange,
  organizationId,
  label = "User",
}) => {
  const { organizationUserService } = useGlobalContext();
  const queryClient = useQueryClient();

  const fetchUsers = async (searchTerm: string) => {
    const response = await queryClient.fetchQuery<ListResponseOfOrganizationUserListItem>(
      ["organizationUsers", organizationId, searchTerm],
      () =>
        organizationUserService.searchOrganizationUsers(
          AdminListRequestOfSearchOrganizationUsersFilter.fromJS({
            organizationId,
            pageNumber: 0,
            pageSize: 20,
            parameters: SearchOrganizationUsersFilter.fromJS({
              searchText: searchTerm === "" ? undefined : searchTerm,
            }),
          })
        )
    );

    return { 
      result: {
        data: response.data,
        total: response.totalRecords,
        page: 0,
        pageSize: 20
      }, 
      forSearchTerm: searchTerm 
    };
  };

  return (
    <SelectEntityAsync<OrganizationUserListItem>
      value={value}
      onChange={onChange}
      textFieldProps={{variant: "outlined"}}
      labelField="email"
      fetchData={fetchUsers}
      failMessage="Failed to load users"
      label={label}
      getOptionLabel={(option) =>
        `${option.email} (${option.organizationName})`
      }
    />
  );
};